export enum RolesEnum {
  Customer = 1,
  Employee = 2,
  Supervisor = 3,
  AuditSupervisor = 4,
  Manager = 5,
  AuditEmployee = 6,
  SuperAdmin = 7,
  ContentWriter = 8,
  Inquiry = 9,
  WalkInEmployee = 10,
  Accountant = 11,
  Court = 12,
  Repaid =13,
  RdcAccess = 14
}
